/**
 * @generated SignedSource<<1c774a8911f438c14fb2c108dc7261b2>>
 * @relayHash 20aa1db3e5dcec5d6322da71b2d44a0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 55a6eaf60c07b634226859504fbc2afe9f4b2d83ce39697f662c523cfaea5460

import type { ConcreteRequest, Query } from 'relay-runtime';
export type graphqlContextPanelQuery$variables = {
  cloudId: string;
  issueId?: string | null | undefined;
};
export type graphqlContextPanelQuery$data = {
  readonly agentAI_contextPanel: {
    readonly __typename: "AgentAIContextPanelResponse";
    readonly nextSteps: string | null | undefined;
    readonly reporterDetails: string | null | undefined;
    readonly suggestedActions: ReadonlyArray<{
      readonly content: {
        readonly description: string | null | undefined;
        readonly title: string | null | undefined;
      } | null | undefined;
      readonly context: {
        readonly currentValue: AGG$JSON | null | undefined;
        readonly fieldId: string | null | undefined;
        readonly fieldName: string | null | undefined;
        readonly fieldType: string | null | undefined;
        readonly suggestion: AGG$JSON | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly suggestedEscalation: string | null | undefined;
    readonly summary: string | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly extensions: ReadonlyArray<{
      readonly errorType: string | null | undefined;
      readonly statusCode: number | null | undefined;
    }> | null | undefined;
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type graphqlContextPanelQuery = {
  response: graphqlContextPanelQuery$data;
  variables: graphqlContextPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueId",
    "variableName": "issueId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "summary"
    },
    {
      "kind": "ScalarField",
      "name": "nextSteps"
    },
    {
      "kind": "ScalarField",
      "name": "reporterDetails"
    },
    {
      "kind": "ScalarField",
      "name": "suggestedEscalation"
    },
    {
      "concreteType": "AgentAISuggestAction",
      "kind": "LinkedField",
      "name": "suggestedActions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "concreteType": "AgentAISuggestedActionContent",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "title"
            },
            {
              "kind": "ScalarField",
              "name": "description"
            }
          ]
        },
        {
          "concreteType": "AgentAISuggestedActionContext",
          "kind": "LinkedField",
          "name": "context",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fieldId"
            },
            {
              "kind": "ScalarField",
              "name": "fieldType"
            },
            {
              "kind": "ScalarField",
              "name": "fieldName"
            },
            {
              "kind": "ScalarField",
              "name": "suggestion"
            },
            {
              "kind": "ScalarField",
              "name": "currentValue"
            }
          ]
        }
      ]
    }
  ],
  "type": "AgentAIContextPanelResponse"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "graphqlContextPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "agentAI_contextPanel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlContextPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "agentAI_contextPanel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "55a6eaf60c07b634226859504fbc2afe9f4b2d83ce39697f662c523cfaea5460",
    "metadata": {},
    "name": "graphqlContextPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "566ae9d1c90b40e64ca9be90435ac041";

export default node;
